import React from 'react';
import get_bundle from '../domain/get_bundle';
import getMadaiURL from '../domain/getMadaiURL';
import Locale from '../domain/Locale';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})
export default class PolicyCookies extends React.Component {
  render() {
    const locale = this.props.locale;
    function getHref() {
      if (locale.toJSON() === 'it_IT') {
        return 'https://it.madai.com/privacy.html';
      } else {
        return "https://madai.com/privacy.html"
      }

      /*const _locale = locale.toString();
      const country = locale.country.toLowerCase();
      if (_locale === 'en_ZA') {
        return 'http://za.shop.madai.com/privacy-policy_en.html';
      } else if (_locale === 'en_US') {
        return 'http://us.shop.madai.com/privacy-policy_en.html';
      } else if (_locale === 'it_IT') {
        return 'http://it.madai.com/privacy-policy_it.html';
      }
      else {
        return getMadaiURL() + country + '/privacy.html';
      }*/
    }
    return <a target='_blank' href={getHref()}>{get_bundle(this.props.locale).footer.policy_cookies}</a>;
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/PolicyCookies.js
 **/